import { render, staticRenderFns } from "./GoodsList.vue?vue&type=template&id=f52c0874&scoped=true"
import script from "./GoodsList.vue?vue&type=script&lang=ts"
export * from "./GoodsList.vue?vue&type=script&lang=ts"
import style0 from "./GoodsList.vue?vue&type=style&index=0&id=f52c0874&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52c0874",
  null
  
)

export default component.exports